export const GET_FILES_PENDING = 'GET_FILES_PENDING'
export const GET_FILES_SUCCESSFUL = 'GET_FILES_SUCCESSFUL'
export const GET_FILES_ERROR = 'GET_FILES_ERROR'
